<script>
export default {
  name: "DelegationInfoView",
  created() {
    if (this.$store.getters["userProperties"].system_settings.is_delegation_task_enabled === 2) {
      this.$router.push("/delegation-info/delegation-task");
    } else {
      this.$router.push("/delegation-info/vehicle");
    }
  }
};
</script>

<style scoped></style>
